// Importing data for News Section
import tendersA from "../assets/NewsTender/Tenders/tendersA Tender Notice for the purchase supply of Tablets Mobile Handsets.pdf";
import tendersB1 from "../assets/NewsTender/Tenders/tendersC Tender Document for Selection of Airlines & Transport Partners.pdf";
import tendersB2 from "../assets/NewsTender/Tenders/tendersB.2 (Tender Documents).jpeg";
import tendersC from "../assets/NewsTender/Tenders/tendersC Tender Document for Selection of Airlines & Transport Partners.pdf";
import tendersD1 from "../assets/NewsTender/Tenders/tendersD.1 Tender Notice for Procurement of State-of-the-Art ICT Digital Platform Under The Directorate General Pakistan Post Office Islamabad.jpg";
import tendersD2 from "../assets/NewsTender/Tenders/tendersD.2 (REVISED TENDER DOCUMENTS).pdf";
import tendersD3 from "../assets/NewsTender/Tenders/tendersD.3 Corrigendum.jpg";
import tendersE1 from "../assets/NewsTender/Tenders/tendersE.1 Tender Notice For Selection Of Transportor Delivery Partners For EMS-PLUS Under The Directorate General Pakistan Post Office Islamabad.jpg";
import tendersE2 from "../assets/NewsTender/Tenders/tendersE.2 (TENDER DOCUMENT) (Agreements).pdf";
import tendersE3 from "../assets/NewsTender/Tenders/tendersE.3 MS DHL Pakistan (Pvt) Limited.pdf";
import tendersE4 from "../assets/NewsTender/Tenders/tendersE.4 MS Gerry's International (Pvt) Limited, a licensee of Federal Express Corporation.pdf";
import tendersE5 from "../assets/NewsTender/Tenders/tendersE.5 MS Universal Logistics (Pvt) Limited, an Authorized service contractor of UPS.pdf";
import tendersE6 from "../assets/NewsTender/Tenders/tendersE.6 MS Focus Technologies (Pvt) Limited.pdf";
import tendersF from "../assets/NewsTender/Tenders/tendersF Baseline Contract Awarded to MS 360 Technologies (Pvt) Ltd. regarding EMTTS, IPS, MDUS and CMS to Director General, Pakistan Post Islamabad.pdf";
import tendersG from "../assets/NewsTender/Tenders/tendersG Contract Awards Proforma - I and II.pdf";
import tenders08 from "../assets/NewsTender/Tenders/tenders08 Tender  Notice for Transportationm Conveyance of Mail Through Contractual State Mail Express (SME)       Under The Postmaster General Northern  Punjab Circle Rawalpindi.jpg";
import tenders09 from "../assets/NewsTender/Tenders/tenders09 Tender  Notice for Supply of Stationery Items        Under The Postmaster General Northern  Sindh  Circle Hyderabad.jpg";
import tenders10 from "../assets/NewsTender/Tenders/tenders10 Tender  Notice for Supply of Stationery.jpg";
import tenders11 from "../assets/NewsTender/Tenders/tenders11 Pre-Qualification Notice for Repair, Maintenance, Construction and Re-Construction Work in Dte-General PPO Islamabad.jpg";
import tenders11B from "../assets/NewsTender/Tenders/tenders11.2 (URDU).jpg";
import tenders12 from "../assets/NewsTender/Tenders/tenders12 Tender Notice for Complete Repair and Maintenance of Existing Cooling Towers or Replacement.jpg";
import tenders13 from "../assets/NewsTender/Tenders/tenders13 Tender  Notice For Purchase of Stationary for the Office of Postmaster General, Southern Punjab Circle, Multan       Under The Postmaster General Southern Punjab Circle Multan.jpeg";
import tenders14 from "../assets/NewsTender/Tenders/tenders14 Tender Notice for Supply of Stationery Items         Under The Postmaster General, Central Punjab Circle Lahore.jpg";
import tenders15 from "../assets/NewsTender/Tenders/tenders15 Pre-Qualification   Notice For Civil Works of Departmental Building.jpeg";
import tenders16 from "../assets/NewsTender/Tenders/tenders16 Tender Notice Regarding Outsourcing of Security Guards Services          Under The Postmaster General, Metropolitan Circle, Karachi.jpg";
import tenders16B from "../assets/NewsTender/Tenders/tenders16.2 (URDU).jpg";
import tenders17 from "../assets/NewsTender/Tenders/tenders17 Tender Notice For Supply of Office Stationery For the Year 2023-24           Under The Postmaster General, Metropolitan Circle, Karachi.pdf";
import tenders18 from "../assets/NewsTender/Tenders/tenders18 Tender Notice for Pre-Qualification of Firms.pdf";
import tenders19 from "../assets/NewsTender/Tenders/tenders19 Tender Notice for Mail Transmission of Six Mail Lines  Under The Postmaster General, Khyber Pakhtunkhwa, Peshawar.jpg";
import tenders20 from "../assets/NewsTender/Tenders/tenders20 Pre-Qualification Notice for Construction, Reconstruction.jpeg";
import tenders20B from "../assets/NewsTender/Tenders/tenders20.2 (URDU).jpeg";
import tenders21 from "../assets/NewsTender/Tenders/tenders21 Pre-Qualification  of Civil Works Contractors for the Year 2023-24            Under The Postmaster General, Metropolitan Circle, Karachi.jpg";
import tenders22 from "../assets/NewsTender/Tenders/tenders22 Tender Notice of (13) Contractual SMES for Transmission of Mail          Under The Postmaster General, Central Punjab Circle Lahore.jpg";
import tenders23 from "../assets/NewsTender/Tenders/tenders23 Tender Notice for Purchase of Stationary Items For DMOs of MST Division Peshawar.jpg";
import tenders24 from "../assets/NewsTender/Tenders/tenders24 Tender  Notice for Purchase of Stationery Items for Northern Punjab Circle Rawalpindi.jpg";
import tenders25 from "../assets/NewsTender/Tenders/tenders25 Pre-Qualification Notice Construction, Reconstruction.jpg";
import tenders26 from "../assets/NewsTender/Tenders/tenders26 Tender Notice for Security Services  Under The Postmaster General Northern  Sindh  Circle Hyderabad.pdf";
import tenders27 from "../assets/NewsTender/Tenders/tenders27 Pre-Qualification Notice for Annual Repair.jpg";
import tenders27B from "../assets/NewsTender/Tenders/tenders27.2 Pre-Qualification Notice for Annual Repair (URDU).jpg";
import tenders28 from "../assets/NewsTender/Tenders/tenders28 Tender Notice for Purchase  Android Mobile Phones Under The Directorate General Pakistan Post.jpg";
import tenders29 from "../assets/NewsTender/Tenders/tenders29 Pre-Qualification Notice For Annual Repair.pdf";
import tenders30 from "../assets/NewsTender/Tenders/tenders30 Tender Notice for Purchase  of Stationery Items Under The Directorate General Pakistan Post.jpg";
import tenders31 from "../assets/NewsTender/Tenders/tenders31 Tender Notice for Purchase  of Other Misc Items Under The Directorate General Pakistan Post.jpg";
import tenders32 from "../assets/NewsTender/Tenders/tenders32 Tender Notice for Transportation of Pakistan Post Airmail World-Wide and Domestice Sector  Under The Directorate General Pakistan Post.jpg";

// Importing data for News Section
import newsA from "../assets/NewsTender/News/newsA Public Notice for Recruitment on ASPOS AS (MST) in Direct Quota Under The Pakistan Post Office Department.pdf";
import newsB from "../assets/NewsTender/News/newsB Same Day Delivery In Twin Cities (Rawalpindi - Islamabad).png";
import newsC from "../assets/NewsTender/News/newsC 51st International Letter-Writing Competition For Young People (2022).jpg";
import news04 from "../assets/NewsTender/News/news04 49th International Letter Writing Competition For Young People 2020.jpg";
import news05 from "../assets/NewsTender/News/news05 Announcement of ISDB Scholarship Programmes for the Academic Year 2020-21.pdf";
import news06 from "../assets/NewsTender/News/news06 Printing And Supply Of 500,000 Security Featured Withdrawal Slips For Savings Bank (Ordinary) And Special Account Under The Directorate General Pakistan Post Office Islamabad.jpg";
import news07 from "../assets/NewsTender/News/news07 Restricting Participation of Institutional Investors in National Savings Schemes.jpg";
import news08 from "../assets/NewsTender/News/news08 Posting Uploading Contract Award of Value Above Rupees Fifty Million ( 50-Million ) On PPRA Website.pdf";
import news09 from "../assets/NewsTender/News/news09 delays in the Delivery of P. O. Mail Abroad Due to COVID-19.jpg";
import news10 from "../assets/NewsTender/News/news10 Announcement of IsDB Scholarship Programmes for the Academic Year 2021-22.pdf";
import news11 from "../assets/NewsTender/News/news11 UMS UMO UMS-COD Service started at Jandanwala Post Office.jpg";
import news12 from "../assets/NewsTender/News/news12 UMS UMO UMS-COD Service started at Khanewal Post Office.jpg";
import news13 from "../assets/NewsTender/News/news13 Baseline Contract Awarded to MS 360 Technologies (Pvt) Ltd. regarding EMTTS, IPS, MDUS and CMS to Director General, Pakistan Post Islamabad.pdf";
import news14 from "../assets/NewsTender/News/news14 E-Commerce Facilitation Centres.pdf";
import news15 from "../assets/NewsTender/News/news15 UMS UMO UMS-COD Service started at Khairpur Nathan Shah Post Office.jpg";
import news16 from "../assets/NewsTender/News/news16 E-Kachehri Holding Online E-Kachery online Khuli Kacheri by Postmaster General Islamabad.jpeg";
import news17 from "../assets/NewsTender/News/news17 UMS UMO UMS-COD Service started at Wan Bhachran  Post Office.jpg";
import news18 from "../assets/NewsTender/News/news18 Provision of Insurance on Express Post Articles ( UMS and UMS-COD ).jpg";
import news19 from "../assets/NewsTender/News/news19 Contract Awards Proforma - I and II.pdf";
import news20 from "../assets/NewsTender/News/news20 UMS UMO UMS-COD Service started at Industrial Estate Multan.jpg";
import news21 from "../assets/NewsTender/News/news21 Annual Procurement Plan of Pakistan Post For The Financial Year 2021-22.jpg";
import news22 from "../assets/NewsTender/News/news22 UMS UMO UMS-COD Service started at Qutab Pur Lodhran.jpg";
import news23 from "../assets/NewsTender/News/news23 Annual Procurement Plan of Pakistan Post For The Financial Year 2021-22.pdf";
import news24 from "../assets/NewsTender/News/news24 List of Prohibited Items According To Pakistan Post Guide.pdf";
import news25 from "../assets/NewsTender/News/news25 EP Services UMS UMO UMS-COD started at Mankera PO Bhakkar.jpg";
import news26 from "../assets/NewsTender/News/news26 Gazette of Pakistan S.R.O.S Dated 31-01-2022.pdf";
import news27 from "../assets/NewsTender/News/news27 51st International Letter Writing Competition.jpg";
import news28 from "../assets/NewsTender/News/news28 EMS-PLUS Service, Tender Documents.pdf";
import news29 from "../assets/NewsTender/News/news29 Gazette of Pakistan S.R.O.S Dated 21-04-2022.pdf";
import news30 from "../assets/NewsTender/News/news30 UMS UMO UMS-COD Service.pdf";
import news31 from "../assets/NewsTender/News/news31 Announcement of Evaluation Report (PPRA Rule 35).jpg";
import news32 from "../assets/NewsTender/News/news32 Procurement Plan for Year 2022-2023.pdf";
import news33 from "../assets/NewsTender/News/news33 Extension of UMO UMS.pdf";
import news34 from "../assets/NewsTender/News/news34 Validated EMS Export.pdf";
import news35 from "../assets/NewsTender/News/news35 Public Notice for Recruitment.pdf";
import news36 from "../assets/NewsTender/News/news36 Extension of Fax Money Order.pdf";
import news37 from "../assets/NewsTender/News/news37 Pakistan Post moves 7.png";
import news38 from "../assets/NewsTender/News/news38 Extension of UMS.pdf";
import news39 from "../assets/NewsTender/News/news39 E-Kachehri.jpeg";

export const TendersData = [
  {
    id: 1,
    title: "Tender Notice for the purchase/ supply of Tablets/Mobile Handsets",
    url: tendersA,
  },
  {
    id: 2,
    title:
      "Tender Notice of Private Partner for Delivery of Urgent Mail Service Plus (UMS-Plus) Under The Directorate General Pakistan Post Office, Islamabad",
    url: tendersB1,
    date: "Tender Documents",
    url2: tendersB2,
  },
  {
    id: 3,
    title: "Tender Document for Selection of Airlines & Transport Partners",
    url: tendersC,
  },
  {
    id: 4,
    title:
      "Tender Notice for Procurement of State-of-the-Art ICT Digital Platform Under The Directorate General Pakistan Post Office Islamabad Opening Date 09-03-2022",
    url: tendersD1,
    date: "REVISED TENDER DOCUMENTS",
    url2: tendersD2,
    title3: "Corrigendum",
    url3: tendersD3,
  },
  {
    id: 5,
    title:
      "Tender Notice For Selection Of Transportor/ Delivery Partners For EMS-PLUS Under The Directorate General Pakistan Post Office Islamabad",
    url: tendersE1,
    title2: "TENDER DOCUMENT",
    url2: tendersE2,
    title3: "M/S DHL Pakistan (Pvt) Limited",
    url3: tendersE3,
    title4:
      "M/S Gerry's International (Pvt) Limited, a licensee of Federal Express Corporation",
    url4: tendersE4,
    title5:
      "M/S Universal Logistics (Pvt) Limited, an Authorized service contractor of UPS",
    url5: tendersE5,
    title6: "M/S Focus Technologies (Pvt) Limited",
    url6: tendersE6,
  },
  {
    id: 6,
    title:
      "Baseline Contract Awarded to M/S 360 Technologies (Pvt) Ltd. regarding EMTTS, IPS, MDUS and CMS to Director General, Pakistan Post Islamabad",
    url: tendersF,
  },
  {
    id: 7,
    title: "Contract Awards Proforma - I and II",
    url: tendersG,
  },
  {
    id: 8,
    title:
      "Tender Notice for Transportation/ Conveyance of Mail Through Contractual State Mail Express (SME) Under The Postmaster General Northern Punjab Circle Rawalpindi",
    url: tenders08,
    date: "06-07-2023",
  },
  {
    id: 9,
    title:
      "Tender Notice for Supply of Stationery Items Under The Postmaster General Northern Sindh Circle Hyderabad",
    url: tenders09,
    date: "11-07-2023",
  },
  {
    id: 10,
    title:
      "Tender Notice for Supply of Stationery/ Special Uniform/ Polythene Bags and Other Stock Items For the Year 2023-24 Under The Postmaster General Federal Capital & Gilgit Baltistan Circle Islamabad",
    url: tenders10,
    date: "17-07-2023",
  },
  {
    id: 11,
    title:
      "Pre-Qualification Notice for Repair, Maintenance, Construction and Re-Construction Work in Dte-General PPO Islamabad Under The Directorate General, Pakistan Post Office G-8/4, Islamabad",
    url: tenders11,
    date: "02-08-2023",
    title2: "(Urdu)",
    url2: tenders11B,
  },
  {
    id: 12,
    title:
      "Tender Notice for Complete Repair and Maintenance of Existing Cooling Towers or Replacement/ Installation and Commissioning of Fiber Glass Cooling Towers ( Bottle Type) and Repair of 2 Nos, of Chiller Manufactured by TRNAE Absorption, 85 Tons Each Installed in Directorate General, Pakistan Post Office, Islamabad Under The Directorate General Pakistan Post G-8/4, Islamabad",
    url: tenders12,
    date: "04-08-2023",
  },
  {
    id: 13,
    title:
      "Tender Notice For Purchase of Stationary for the Office of Postmaster General, Southern Punjab Circle, Multan Under The Postmaster General Southern Punjab Circle Multan",
    url: tenders13,
    date: "07-08-2023",
  },
  {
    id: 14,
    title:
      "Tender Notice for Supply of Stationery Items Under The Postmaster General, Central Punjab Circle Lahore",
    url: tenders14,
    date: "03-08-2023",
  },
  {
    id: 15,
    title:
      "Pre-Qualification Notice For Civil Works of Departmental Building which fall under the jurisdiction of the Postmaster General, Southern Punjab Circle Multan for the Financial Year 2023-24 Under The Postmaster General Southern Punjab Circle Multan",
    url: tenders15,
    date: "28-07-2023",
  },
  {
    id: 16,
    title:
      "Tender Notice Regarding Outsourcing of Security Guards Services Under The Postmaster General, Metropolitan Circle, Karachi",
    url: tenders16,
    date: "08-08-2023",
    title2: "(Urdu)",
    url2: tenders16B,
  },
  {
    id: 17,
    title:
      "Tender Notice For Supply of Office Stationery For the Year 2023-24 Under The Postmaster General, Metropolitan Circle, Karachi",
    url: tenders17,
    date: "02-08-2023",
  },
  {
    id: 18,
    title:
      "Tender Notice for Pre-Qualification of Firms/ / Venders / Workshops for Repair / Maintenance of Vehicles Under The Directorate General Pakistan Post G-8/4, Islamabad",
    url: tenders18,
    date: "10-08-2023",
  },
  {
    id: 19,
    title:
      "Tender Notice for Mail Transmission of Six Mail Lines Under The Postmaster General, Khyber Pakhtunkhwa, Peshawar",
    url: tenders19,
    date: "08-08-2023",
  },
  {
    id: 20,
    title:
      "Pre-Qualification Notice for Construction, Reconstruction/ Repair and Maintenance of Buildings, Water Supply and Electricity Work Etc. For Financial Year 2023-24 Relating to PMG, KP Circle Peshawar Under The Postmaster General, Khyber Pakhtunkhwa, Peshawar (Urdu)",
    url: tenders20,
    date: "07-08-2023",
    title2: "(Urdu)",
    url2: tenders20B,
  },
  {
    id: 21,
    title:
      "Pre-Qualification of Civil Works Contractors for the Year 2023-24 Under The Postmaster General, Metropolitan Circle, Karachi",
    url: tenders21,
    date: "16-08-2023",
  },
  {
    id: 22,
    title:
      "Tender Notice of (13) Contractual SMES for Transmission of Mail Under The Postmaster General, Central Punjab Circle Lahore",
    url: tenders22,
    date: "10-08-2023",
  },
  {
    id: 23,
    title:
      "Tender Notice for Purchase of Stationary Items For DMOs of MST Division Peshawar Under The Postmaster General, Khyber Pakhtunkhwa, Peshawar",
    url: tenders23,
    date: "10-08-2023",
  },
  {
    id: 24,
    title:
      "Tender Notice for Purchase of Stationery Items for Northern Punjab Circle Rawalpindi and its Units for the Year 2023-24 Under The Postmaster General Northern Punjab Circle Rawalpindi",
    url: tenders24,
    date: "16-08-2023",
  },
  {
    id: 25,
    title:
      "Pre-Qualification Notice Construction, Reconstruction / Repair and Maintenance of Buildings, Water Supply and Electricity Work etc. For Financial Year 2023-24 Under The Postmaster General Northern Sindh Circle Hyderabad",
    url: tenders25,
    date: "21-08-2023",
  },
  {
    id: 26,
    title:
      "Tender Notice for Security Services Under The Postmaster General Northern Sindh Circle Hyderabad",
    url: tenders26,
    date: "21-08-2023",
  },
  {
    id: 27,
    title:
      "Pre-Qualification Notice for Annual Repair, Petty Repair, Electric, Sanitary, Construction, Re-Construction, works at Departmental Buildings situated at different locations for Financial Year 2023-24 Under The Postmaster General, Northern Punjab Circle, Rawalpindi",
    url: tenders27,
    date: "28-08-2023",
    title2: "(Urdu)",
    url2: tenders27B,
  },
  {
    id: 28,
    title:
      "Tender Notice for Purchase Android Mobile Phones Under The Directorate General Pakistan Post G-8/4, Islamabad",
    url: tenders28,
    date: "04-9-2023",
  },
  {
    id: 29,
    title:
      "Pre-Qualification Notice For Annual Repair, Petty Repair, Construction, Reconstruction / Repair and Maintenance of Buildings, Water Supply and Electricity Work etc. For Financial Year 2023-24 Under The Postmaster General FC & GB Circle Islamabad",
    url: tenders29,
    date: "04-9-2023",
  },
  {
    id: 30,
    title:
      "Tender Notice for Purchase of Stationery Items Under The Directorate General Pakistan Post G-8/4, Islamabad",
    url: tenders30,
    date: "20-09-2023",
  },
  {
    id: 31,
    title:
      "Tender Notice for Purchase of Other/ Misc Items Under The Directorate General Pakistan Post G-8/4, Islamabad",
    url: tenders31,
    date: "21-09-2023",
  },
  {
    id: 32,
    title:
      "Tender Notice for Transportation of Pakistan Post Airmail World-Wide and Domestice Sector Under The Directorate General Pakistan Post G-8/4, Islamabad",
    url: tenders32,
    date: "02-10-2023",
  },
];

export const NewsData = [
  {
    id: 1,
    title:
      "Public Notice for Recruitment on ASPOS/ AS (MST) in Direct Quota Under The Pakistan Post Office Department",
    date: "2021-01-01",
    url: newsA,
  },
  {
    id: 2,
    title: "Same Day Delivery In Twin Cities (Rawalpindi - Islamabad)",
    url: newsB,
  },
  {
    id: 3,
    title:
      "51st International Letter-Writing Competition For Young People (2022)",
    url: newsC,
  },
  {
    id: 4,
    title:
      "  49th International Letter Writing Competition For Young People 2020",
    url: news04,
  },
  {
    id: 5,
    title:
      " Announcement of ISDB Scholarship Programmes for the Academic Year 2020-21",
    url: news05,
  },
  {
    id: 6,
    title:
      " Printing And Supply Of 500,000 Security Featured Withdrawal Slips For Savings Bank (Ordinary) And Special Account Under The Directorate General Pakistan Post Office Islamabad",
    url: news06,
  },
  {
    id: 7,
    title:
      "Restricting Participation of Institutional Investors in National Savings Schemes",
    url: news07,
  },
  {
    id: 8,
    title:
      "Posting/ Uploading Contract Award of Value Above Rupees Fifty Million (50-Million) On PPRA Website",
    url: news08,
  },
  {
    id: 9,
    title: "Delays in the Delivery of P. O. Mail Abroad Due to COVID-19",
    url: news09,
  },
  {
    id: 10,
    title:
      "Announcement of IsDB Scholarship Programmes for the Academic Year 2021-22",
    url: news10,
  },
  {
    id: 11,
    title: "UMS/ UMO/ UMS-COD Service started at Jandanwala Post Office",
    url: news11,
  },
  {
    id: 12,
    title: "UMS/ UMO/ UMS-COD Service started at Khanewal Post Office",
    url: news12,
  },
  {
    id: 13,
    title: "E-Commerce Facilitation Centres",
    url: news13,
  },
  {
    id: 14,
    title:
      "Baseline Contract Awarded to M/S 360 Technologies (Pvt) Ltd. regarding EMTTS, IPS, MDUS and CMS to Director General, Pakistan Post Islamabad",
    url: news14,
  },
  {
    id: 15,
    title:
      "UMS/ UMO/ UMS-COD Service started at Khairpur Nathan Shah Post Office",
    url: news15,
  },
  {
    id: 16,
    title:
      "E-Kachehri: Holding Online E-Kachery / online Khuli Kacheri by Postmaster General Islamabad",
    url: news16,
  },
  {
    id: 17,
    title: "UMS/ UMO/ UMS-COD Service started at Wan Bhachran Post Office",
    url: news17,
  },
  {
    id: 18,
    title: "Provision of Insurance on Express Post Articles (UMS and UMS-COD)",
    url: news18,
  },
  {
    id: 19,
    title: "Contract Awards Proforma - I and II",
    url: news19,
  },
  {
    id: 20,
    title: "UMS/ UMO/ UMS-COD Service started at Industrial Estate Multan",
    url: news20,
  },
  {
    id: 21,
    title:
      "Annual Procurement Plan of Pakistan Post For The Financial Year 2021-22",
    url: news21,
  },
  {
    id: 22,
    title: "UMS/ UMO/ UMS-COD Service started at Qutab Pur Lodhran",
    url: news22,
  },
  {
    id: 23,
    title:
      "Annual Procurement Plan of Pakistan Post For The Financial Year 2021-22",
    url: news23,
  },
  {
    id: 24,
    title: "List of Prohibited Items According To Pakistan Post Guide",
    url: news24,
  },
  {
    id: 25,
    title: "EP Services UMS/ UMO/ UMS-COD started at Mankera PO Bhakkar",
    url: news25,
  },
  {
    id: 26,
    title: "Gazette of Pakistan S.R.O.S Dated 31-01-2022",
    url: news26,
  },
  {
    id: 27,
    title:
      "51st International Letter Writing Competition For Young People (2022)",
    url: news27,
  },
  {
    id: 28,
    title:
      "EMS-PLUS Service, Tender Documents and Agreements under the Director General, Pakistan Post Islamabad",
    url: news28,
  },
  {
    id: 29,
    title: "Gazette of Pakistan S.R.O.S Dated 21-04-2022",
    url: news29,
  },
  {
    id: 30,
    title: "UMS/ UMO/ UMS-COD Service started at District Muzaffarabad",
    url: news30,
  },
  {
    id: 31,
    title: "Announcement of Evaluation Report (PPRA Rule 35)",
    url: news31,
  },
  {
    id: 32,
    title:
      "Procurement Plan for Year 2022-2023 Under the Dte-General, Pakistna Post Islamabad",
    url: news32,
  },
  {
    id: 33,
    title:
      "Extension of UMO/ UMS-COD Service District Muzaffarabad & Rawalakot",
    url: news33,
  },
  {
    id: 34,
    title: "Validated EMS Export Standards For Pakistan",
    url: news34,
  },
  {
    id: 35,
    title:
      "Public Notice for Recruitment on ASPOS/ AS (MST) in Direct Quota Under The Pakistan Post Office Department",
    url: news35,
  },
  {
    id: 36,
    title:
      "Extension of Fax Money Order Service At Kotli Sattian Post Office (HSG) Under DSPS Murree Kahuta Division Rawalpindi",
    url: news36,
  },
  {
    id: 37,
    title:
      "Pakistan Post moves 7 steps upwards in World Postal Ranking by UPU. International Ranking of Postal Sector is based on four pillars i.e. Reliability, Reach, Relevance and Resilience. In 2022, Pakistan Post has achieved 55th position out of 162 countries in the Postal Ranking Index issued by Universal Postal Union.",
    url: news37,
  },
  {
    id: 38,
    title:
      "Extension of UMS, UMO & EMS Service Dugal Post Office under DSPS Sialkot Division",
    url: news38,
  },
  {
    id: 39,
    title:
      "E-Kachehri: Honourable Chairman / Director General will hold E-Kachehri on 17-Aug-2023 (Thursday) from 11.00 A.M. to 1.00 P.M",
    url: news39,
  },
];
